export class ModelManager {
    private viewer?: Autodesk.Viewing.GuiViewer3D | null;
    private model?: Autodesk.Viewing.Model | null;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.viewer = viewer;
    }

    async load(urn: string): Promise<void> {
        if (!urn) return Promise.resolve();

        return new Promise((resolve, reject) => {
            Autodesk.Viewing.Document.load(
                `urn:${urn}`,
                async (doc) => {
                    const viewable = doc.getRoot().search({ role: '3d' })[0];

                    this.model = await this.viewer!.loadDocumentNode(doc, viewable);

                    resolve();
                },
                (code, msg, errors) => {
                    console.log(errors);
                    reject(new Error(`Document load failed: ${code} ${msg}`));
                }
            );
        });
    }

    unload() {
        // Unload model if present
        if (this.viewer && this.model) {
            try {
                this.viewer.unloadModel(this.model);
            } catch (e) {
                console.warn('Error unloading model:', e);
            }
            this.model = null;
        }
    }
}
